import { IContact } from "./Contact";
import { ITagQuery } from "./TagQueryTypes";

export type IEmailType =
  | "draft"
  | "schedule"
  | "sent"
  | "cancelled"
  | "confirmation"
  | "campaign"
  | "dump"
  | "test";

export type IFontType = "Arial" | "Sans Serif" | "Courier New";

export enum IContactEmailType {
  "BROADCAST" = "BROADCAST",
  "CAMPAIGN" = "CAMPAIGN",
  "CONFIRMATION" = "CONFIRMATION",
  "PERSONAL" = "PERSONAL",
}

export enum IContactEmailStatus {
  "OPENED" = "OPENED",
  "UNOPENED" = "UNOPENED",
  "CLICKED" = "CLICKED",
  "COMPLAINED" = "REPORTED",
}

export interface IEmailOptions {
  _id?: string;
  fromName?: string;
  signature?: string;
  additionalFooterText?: string;
  textBeforeUnsubscribe?: string;
  textAfterUnsubscribe?: string;
  address: string;
  automaticallyTimeZone: boolean;
  timeZone: string;
  AlwaysMakeFirstLineSubject: boolean;
  AlwaysAddExtraCarriage: boolean;
  SaveLastSearchPreferences: boolean;

  event?: {
    summary: string;
    description: string;
    location: string;
    recurrence?: string;
    start: Date;
    duration: number;
  };
  maxWidth?: number | null;

  autoBoldLinks?: boolean;

  showOnArchive?: boolean;
  splitTesting?: boolean;

  font: {
    family: string;
    size: string;
  };
  delayed: string;
}

export interface IEmail {
  _id: string;
  userUid: string;
  subject: string;

  // Properties for an email when he's in A/B Split mode
  splitSubject?: string;
  splitMode?: "AGE" | "DOMAIN" | "AGE_DOMAIN";

  body: string;
  labels: string[];
  font: IFontType;
  isFavorite: boolean;
  type: IEmailType;
  emailOptions: IEmailOptions;
  scheduleTo?: Date;
  createdAt: Date;
  updatedAt: Date;
  contactsSentTo?: IContact[];
  tagQuery?: ITagQuery;
  searchId: string | null;
  isPersonal?: boolean;
}
